import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import SideBar from '../SideBar';
import Loaders from '../Loaders';

const Layout = ({ children, showTemplate }) => {
  const location = useLocation();
  const isChatRoute =
    location.pathname === '/chat' ||
    location.pathname === '/dashboard' ||
    /^\/chat\//.test(location.pathname);

  if (!showTemplate) {
    return <div className="min-h-screen bg-paper text-ink">{children}</div>;
  }

  return (
    <div className="min-h-screen flex bg-paper text-ink">
      <SideBar />
      <div className="flex-1 flex flex-col min-w-0 bg-paper min-h-0 h-screen">
        <main className={`flex-1 min-h-0 ${isChatRoute ? 'overflow-hidden flex flex-col' : 'overflow-y-auto'}`}>
          <Suspense fallback={<Loaders viewLoader />}>{children}</Suspense>
        </main>
      </div>
    </div>
  );
};

export default Layout;
